module.exports = __webpack_public_path__ + "img/fenmain.2b9142bb.png";